export const rolePermissions = {
  Admin: {
    sidebar: ["AllContracts", "Templates", "UserManagement", "Trash", "Recent", "Categories", "Favourite","Master","Roles","ContractStatus","ContractTypes","Practices","Departments","Currency","Currencies","AdminDashboard","WIPContracts","Clients","IncompleteContracts"
    ],
    actions: true,
  },
  LegalReviewer: {
    sidebar: ["AllContracts", "Templates", "Trash", "Recent", "Categories", "Favourite","WIPContracts"],
    actions: true,
  },
  LegalUser: {
    sidebar: ["AllContracts", "Templates", "Trash", "Recent", "Categories", "Favourite","WIPContracts","IncompleteContracts"],
    actions: true,
  },
  Finance: {
    sidebar: ["AllContracts","Favourite","Categories"],
    actions: false,
  },
  ProjectManagementOffice: {
    sidebar: ["AllContracts","Favourite","Categories"],
    actions: false,
  },
  TalentAcquisitionGroup: {
    sidebar: ["AllContracts","Favourite","Categories"],
    actions: false,
  },
  ClientPartners: {
    sidebar: ["AllContracts","Favourite","Categories","WIPContracts","IncompleteContracts"],
    actions: false,
  },
  Master: {
    sidebar: ["AllContracts","Favourite","Categories"],
    actions: false
  }
};
